import React, { useEffect } from "react";
import SafeIcon from "../../../common/SafeIcon";
import * as FiIcons from "react-icons/fi";
import ClientReportTable from "../reports/ClientReportTable";

export default function ClientReportPreviewModal({ report, businessName, currency, onClose, onExport }) {
  useEffect(() => {
    if (!report) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose, report]);

  if (!report) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-950/50 p-3 sm:p-6" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section role="dialog" aria-modal="true" aria-labelledby="report-preview-title" className="flex max-h-[92vh] w-full max-w-6xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
        <header className="flex items-start justify-between gap-4 border-b border-slate-200 p-5">
          <div>
            <p className="text-xs font-bold uppercase tracking-wider text-violet-700">{businessName}</p>
            <h2 id="report-preview-title" className="mt-1 text-xl font-black text-slate-900">{report.title}</h2>
            <p className="mt-1 text-xs text-slate-500">{report.period} · Generated {new Date().toLocaleString()}</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Close report preview" className="rounded-lg p-2 text-slate-500 hover:bg-slate-100">
            <SafeIcon icon={FiIcons.FiX} />
          </button>
        </header>
        <div className="min-h-0 flex-1 overflow-auto p-4 sm:p-6">
          <ClientReportTable columns={report.columns} rows={report.rows} currency={currency} />
        </div>
        <footer className="flex justify-end gap-2 border-t border-slate-200 p-4">
          <button type="button" onClick={onClose} className="rounded-xl border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700">Close</button>
          <button type="button" onClick={onExport} className="inline-flex items-center gap-2 rounded-xl bg-violet-600 px-4 py-2 text-sm font-bold text-white hover:bg-violet-700">
            <SafeIcon icon={FiIcons.FiDownload} /> Export CSV
          </button>
        </footer>
      </section>
    </div>
  );
}